import departureApi from "@/services/api/departure";

function extractManifest(response) {
  const manifest =
    response && response.data && response.data.manifest
      ? response.data.manifest
      : null;

  if (!manifest) throw new Error("Missing manifest");
  return manifest;
}

export async function getDepartureManifest(departureId) {
  const response = await departureApi.getManifest(departureId);
  return extractManifest(response);
}

export function ensureManifestArray(manifest, key) {
  if (!manifest || !key) return [];
  if (!Array.isArray(manifest[key])) {
    manifest[key] = [];
  }
  return manifest[key];
}

export async function mutateAndSaveDepartureManifest(departureId, mutate) {
  const manifest = await getDepartureManifest(departureId);
  await mutate(manifest);
  await departureApi.updateManifest(departureId, manifest);
  return manifest;
}
